import { lazy, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import "./index.css";
import { AuthProvider } from "./context/AuthContext.tsx";
import { PrivateRoute } from "./components/auth/PrivateRoute.tsx";
import { PERMISOS } from "./constants/permissions.ts";
import { Toaster } from "./components/ui/sonner";
import { MasterDataLayout } from "./components/master-data/MasterDataLayout.tsx";

const Home = lazy(() => import("./pages/Home.tsx"));
const LoginPage = lazy(() => import("./pages/Login.tsx"));
const Groups = lazy(() => import("./pages/negotiations/Groups.tsx"));
const RotationInventory = lazy(() => import("./pages/negotiations/RotationInventory.tsx"));
const Agreements = lazy(() => import("./pages/negotiations/Agreements.tsx"));
const EffectivenessSupplies = lazy(
  () => import("./pages/negotiations/EffectivenessSupplies.tsx")
);
const Bonuses = lazy(() => import("./pages/negotiations/Bonuses.tsx"));
const Growth = lazy(
  () => import("./pages/negotiations/Growth.tsx")
);
const Approvals = lazy(() => import("./pages/management/Approvals.tsx"));
const Invoices = lazy(() => import("./pages/management/Invoices.tsx"));
const TemplateRecipients = lazy(
  () => import("./pages/maestros/template-recipients/TemplateRecipients.tsx")
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <MasterDataLayout>
                  <Home />
                </MasterDataLayout>
              </PrivateRoute>
            }
          >
            <Route
              index
              element={
                <PrivateRoute requiredPermission={PERMISOS.COMPRAS.VER_GESTION}>
                  <Invoices />
                </PrivateRoute>
              }
            />
            <Route
              path="groups"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.NEGOCIACIONES.VER_GRUPOS}
                >
                  <Groups />
                </PrivateRoute>
              }
            />
            <Route
              path="agreements"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.NEGOCIACIONES.VER_GRUPO_ESCALAS}
                >
                  <Agreements />
                </PrivateRoute>
              }
            />
            <Route
              path="growth"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.NEGOCIACIONES.VER_CRECIMIENTO}
                >
                  <Growth />
                </PrivateRoute>
              }
            />
            <Route
              path="effectiveness-supplies"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.NEGOCIACIONES.VER_ESCALAS_EFECTIVAS}
                >
                  <EffectivenessSupplies />
                </PrivateRoute>
              }
            />
            <Route
              path="bonuses"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.NEGOCIACIONES.VER_BONIFICACIONES}
                >
                  <Bonuses />
                </PrivateRoute>
              }
            />
            <Route
              path="rotation-inventory"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.NEGOCIACIONES.VER_UNIFICADOS}
                >
                  <RotationInventory />
                </PrivateRoute>
              }
            />
            <Route
              path="approvals"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.COMPRAS.VER_APROBACIONES}
                >
                  <Approvals />
                </PrivateRoute>
              }
            />
            <Route
              path="invoices"
              element={
                <PrivateRoute requiredPermission={PERMISOS.COMPRAS.VER_GESTION}>
                  <Invoices />
                </PrivateRoute>
              }
            />
            <Route
              path="maestros/template-recipients"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.MAESTROS.VER_TEMPLATE_RECIPIENTS}
                >
                  <TemplateRecipients />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  </StrictMode>
);
